import styled from 'styled-components';
import { LoadingOverlayStyled } from 'styles/common';

export const DocumentsModal = styled.div`
  position: relative;
  padding: 4px;
  height: 82vh;
  overflow: auto;
  .document_list {
    min-height: 100px;
  }
  .qmt-ui-table__head {
    padding: 4px;
  }
    
  ${LoadingOverlayStyled} {
    position: fixed;
  }
`;

export const Controls = styled.div`
  display: flex;
  justify-content: end;
  margin-top: 20px;
`;

export const DocNotice = styled.div`
  padding-top: 8px;
  ${({ theme }) => theme.text.small};
  color: ${({ theme }) => theme.colors.ternary};
`;
